export const saveColumnChecked = (type, checkedColumns) => {
  localStorage[type] = checkedColumns;
}
export const getColumnChecked = (type) => {
  return localStorage[type];
}
